// components/forms/Step2Form.tsx
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ValuationFormValues } from "@/store/valuationFormStore";
import { MapPin } from "lucide-react";
import React from "react";
import { useFormContext } from "react-hook-form";

const Step2Form: React.FC = () => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<ValuationFormValues>();

  const hasAnnexBuilding = watch("hasAnnexBuilding");
  const hasOutsideKitchen = watch("hasOutsideKitchen");
  const hasGarden = watch("hasGarden");

  return (
    <div className="space-y-6 p-6">
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">Amenities</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("hasAnnexBuilding")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700"> Annex Building</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("hasOutsideKitchen")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700"> Outside Kitchen</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("hasGarden")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700"> Garden</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("hasElectricity")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700"> Electricity</span>
          </label>
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("hasWater")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700"> Water</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("hasPavedParking")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700"> Paved Parking</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              {...register("accessToRoad")}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700">Access to Road</span>
          </label>
        </div>
      </div>

      {/* Building Areas */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Building Components
        </h3>
      </div>

      {/* Descriptions */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Foundation Description
            </label>
            <textarea
              {...register("outsideKitchenDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the outside kitchen"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Roof Description
            </label>
            <textarea
              {...register("waterTankDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the water tank"
            />
          </div>

          

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Walls Description
            </label>
            <textarea
              {...register("soilDrainageDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the Walls"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Doors & Windows Description
            </label>
            <textarea
              {...register("pvcPipesDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the Doors & Windows"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Floor Description
            </label>
            <textarea
              {...register("washTapsDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the wash taps"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Ceiling Description
            </label>
            <textarea
              {...register("fixturesFittingsDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe Ceiling"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
               Accomodation Description
            </label>
            <textarea
              {...register("landscapingDescription")}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe Accomodation"
            />
          </div>
        </div>
      </div>

      {/* Building Description */}

      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Building Description
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Roof Condition
            </label>
            <select
              {...register("roofCondition")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Excellent">Excellent</option>
              <option value="Good">Good</option>
              <option value="Average">Average</option>
              <option value="Poor">Poor</option>
              <option value="Needs Repair">Needs Repair</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Walls Condition
            </label>
            <select
              {...register("wallsCondition")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Excellent">Excellent</option>
              <option value="Good">Good</option>
              <option value="Average">Average</option>
              <option value="Poor">Poor</option>
              <option value="Needs Repair">Needs Repair</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Windows Condition
            </label>
            <select
              {...register("windowsCondition")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Excellent">Excellent</option>
              <option value="Good">Good</option>
              <option value="Average">Average</option>
              <option value="Poor">Poor</option>
              <option value="Needs Repair">Needs Repair</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Doors Condition
            </label>
            <select
              {...register("doorsCondition")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Excellent">Excellent</option>
              <option value="Good">Good</option>
              <option value="Average">Average</option>
              <option value="Poor">Poor</option>
              <option value="Needs Repair">Needs Repair</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Floor Condition
            </label>
            <select
              {...register("floorCondition")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Excellent">Excellent</option>
              <option value="Good">Good</option>
              <option value="Average">Average</option>
              <option value="Poor">Poor</option>
              <option value="Needs Repair">Needs Repair</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Roof Type
            </label>
            <select
              {...register("roofType")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Iron Sheets">Iron Sheets</option>
              <option value="Tiles">Tiles</option>
              <option value="Concrete">Concrete</option>
              <option value="Thatch">Thatch</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Bedrooms *
            </label>
            <input
              type="number"
              {...register("bedrooms", {
                required: "Number of bedrooms is required",
                valueAsNumber: true,
                min: { value: 0, message: "Bedrooms cannot be negative" },
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter number of bedrooms"
            />
            {errors.bedrooms && (
              <p className="mt-1 text-sm text-red-600">
                {errors.bedrooms.message}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Bathrooms *
            </label>
            <input
              type="number"
              {...register("bathrooms", {
                required: "Number of bathrooms is required",
                valueAsNumber: true,
                min: { value: 0, message: "Bathrooms cannot be negative" },
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter number of bathrooms"
            />
            {errors.bathrooms && (
              <p className="mt-1 text-sm text-red-600">
                {errors.bathrooms.message}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Building Details */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Adjustments & Variables
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Year of Construction *
            </label>
            <input
              type="number"
              {...register("yearOfConstruction", {
                required: "Year of construction is required",
                valueAsNumber: true,
                min: { value: 1900, message: "Year must be after 1900" },
                max: {
                  value: new Date().getFullYear(),
                  message: "Year cannot be in the future",
                },
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter year of construction"
            />
            {errors.yearOfConstruction && (
              <p className="mt-1 text-sm text-red-600">
                {errors.yearOfConstruction.message}
              </p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Effective Age (years)
            </label>
            <input
              type="number"
              {...register("effectiveAge", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter effective age"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Annual Depreciation Rate (%)
            </label>
            <input
              type="number"
              {...register("annualDepreciationRate", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter depreciation rate"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Unit Price
            </label>
            <input
              type="number"
              {...register("unitPrice", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter unit price"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Constructed Area (m²)
            </label>
            <input
              type="number"
              {...register("constructedArea", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter constructed area"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Original Cost of Construction
            </label>
            <input
              type="number"
              {...register("originalCostOfConstruction", {
                valueAsNumber: true,
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter original cost"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Maintenance Coefficient
            </label>
            <input
              type="number"
              {...register("maintenanceCoefficient", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter maintenance coefficient"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* Depreciated Value (RWF) */}
              Depreciated Value

            </label>
            <input
              type="number"
              {...register("depreciatedValue", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter depreciated value"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* Present Value (RWF) */}
              Present Value 
            </label>
            <input
              type="number"
              {...register("presentValue", { valueAsNumber: true })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter present value"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Step2Form;
